<template>
  <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>부품마스터</v-toolbar-title>
            <v-spacer/>
            <v-dialog
                    v-model="dialog" persistent
                    width="600px"
                    height="600px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">추가하기</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-text-field v-model="editedItem.name" label="부품명"/>
                            <v-text-field v-model="editedItem.model" label="부품코드"/>
                            <v-text-field v-model="editedItem.code" label="부품품목코드"/>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" @click="saveItem">저장</v-btn>
                        <v-btn color="primary" @click="close">취소</v-btn>
                    </v-card-actions>

                </v-card>

            </v-dialog>
        </v-toolbar>
      <v-data-table
              :headers="headers"
              :items="DataList"
              sort-by="name"
      >
          <template v-slot:item.action="{ item }">
              <v-btn color="primary" small @click="editItem(item)" class="ma-1">
                  <v-icon
                          left
                          small
                  >
                      mdi-border-color
                  </v-icon>
                  <span>수정</span>
              </v-btn>
              <v-btn color="primary" small @click="deleteItem(item)" class="ma-1">
                  <v-icon
                          left
                          small
                  >
                      mdi-eraser-variant
                  </v-icon>
                  <span>삭제</span>
              </v-btn>
          </template>

      </v-data-table>

  </div>
</template>

<script>
export default {
  name: 'PartMaster',

  data: () => ({
    dialog: false,
    headers: [
      {
        text: '부품명',
        sortable: true,
        value: 'name'
      },
      { text: '부품코드',
        value: 'model'
      },
      { text: '부품품목코드',
        value: 'code'
      },
      { text: '',
        align: 'right',
        value: 'action',
        sortable: false
      }
    ],
    DataList: [],
    editedIndex: -1,
    editedItem: {
      _id: '',
      name: '',
      model: '',
      code: ''
    },
    defaultItem: {
      _id: '',
      name: '',
      model: '',
      code: ''
    }
  }),

  created () {
    this.getItemList()
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '추가하기' : '수정하기'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  methods: {

    getItemList () {
      // DB 리스트 가져오기.
      this.DataList = []
      this.$axios.get('/api/parts', this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded get parts -> ' + res)
          for (let i = 0; i < res.data.length; i++) {
            this.DataList.push(res.data[i])
          }
        })
        .catch((e) => {
          console.log('failed get parts -> ' + JSON.stringify(e.response.data))
        })
    },

    saveItem () {
      if (this.editedItem.name.length === 0) {
        this.$dialog.alert('부품명을 입력해 주세요.', { okText: '확인' }).then(function (dialog) {
        })
        return
      }
      if (this.editedItem.model.length === 0) {
        this.$dialog.alert('부품코드를 입력해 주세요.', { okText: '확인' }).then(function (dialog) {
        })
        return
      }
      if (this.editedItem.code.length === 0) {
        this.$dialog.alert('부품품목코드를 입력해 주세요.', { okText: '확인' }).then(function (dialog) {
        })
        return
      }
      if (this.editedIndex > -1) {
        // 부품 마스터 수정.
        this.$axios.put('/api/parts', this.editedItem, this.$Common.headerApiRequest())
            .then((res) => {
              console.log('succeeded put parts -> ' + res)
              Object.assign(this.DataList[this.editedIndex], this.editedItem)
              this.close()
              this.$dialog.alert('부품 마스터가 수정 되었습니다.', { okText: '확인' }).then(function () {
              })
            })
            .catch((e) => {
              console.log('failed put parts -> ' + JSON.stringify(e.response.data))
            })
      } else {
        // 부품 마스터 추가.
        this.$axios.post('/api/parts', this.editedItem, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded post parts -> ' + res)
          this.DataList.push(this.editedItem)
          this.close()
          this.$dialog.alert('부품 마스터가 추가 되었습니다.', { okText: '확인' }).then(function () {
          })
        })
        .catch((e) => {
          console.log('failed post parts -> ' + JSON.stringify(e.response.data))
        })
      }
    },

    deleteItem: function (item) {
      // 부품 마스터 삭제.
      const self = this
      this.$dialog
        .confirm('이 정보를 삭제하시겠습니까?', { okText: '확인', cancelText: '취소' })
        .then(function () {
          self.$axios.delete('/api/parts/' + item.id, self.$Common.headerApiRequest())
          .then(() => {
            console.log('succeeded delete parts')
            self.$dialog.alert('부품 마스터가 삭제 되었습니다.', { okText: '확인' }).then(function () {
              const index = self.DataList.indexOf(item)
              self.DataList.splice(index, 1)
            })
          })
          .catch((e) => {
            console.log('failed delete parts -> ' + JSON.stringify(e.response.data))
          })
        })
        .catch(function () {
        })
    },

    editItem: function (item) {
      this.editedIndex = this.DataList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }

  }
}
</script>

<style scoped/>
